import request from '@/api/axios';

function ltransformRequest(params) {
  let ret = "";
  for (let it in params) {
    ret += encodeURIComponent(it) + "=" + encodeURIComponent(params[it]) + "&";
  }
  return ret;
}
// 判断登录状态
export const Is_Login = (params) => {
  // let paramsApi = ltransformRequest(params)
  // return request({
  //   url: '/auth/oauth/check_token',
  //   method: 'post',
  //   data: paramsApi
  // })
}

// 获取banner
export const getBanner = () => {
  return request({
    url: '/oms/center/api/banner/list',
    method: 'get',
    data: {
      type: 0,
      isApi2: true
    }
  });
};

// banner点击事件
export const clickBanner = (id: number) => {
  return request({
    url: '/oms/center/api/banner/click',
    method: 'get',
    data: {
      id,
      isApi2: true
    }
  });
};

// 根据广告编号，获取广告数据
export const getBannerByCode = (code: string) => {
  return request({
    url: '/oms/center/api/banner/getBannerByCode',
    method: 'get',
    data: {
      code,
      isApi2: true
    }
  });
};

// 获取商品分类
export const getmenu = () => {
  // return request({
  //   url: '/product/api/catalog/tree',
  //   method: 'get',
  // });
};

//获取一级商品分类
export const getmenu1 = () => {
  const params = {
    isApi2: true
  }
  return request({
    url: '/commodity/center/api/product/category1/getAll',
    method: 'get',
    data: params
  });
};

// 供应商
export const getBrand = () => {
  // return request({
  //   url: '/product/api/brand/tenantId',
  //   method: 'get'
  // })
}

//友情链接
export const getLink = () => {
  // return request({
  //   url: '/cms/api/friendlyLink/bottomList',
  //   method: 'get'
  // })
}

// 搜索推荐
export const getSearchProduce = () => {
  return request({
    url: '/user/center/api/dict/type',
    method: 'get',
    data: {
      type: 'SEARCH_PROMPT',
      isApi2: true
    }
  })
}


// 智能补全推荐
export const getTipsProduce = (params: object) => {
  params.isApi2 = true
  return request({
    url: '/commodity/center/api/search/tips/page',
    method: 'post',
    data: params
  })
}

// 智能补全点击次数
export const getTipsProduceClick = (params: object) => {
  // return request({
  //   url: '/product/api/search/tips/update',
  //   method: 'get',
  //   data: params
  // })
}

// 新品推荐
export const getNewRecommend = () => {
  // return request({
  //   url: '/product/api/recommend/recommend',
  //   method: 'get',
  // })
}
// 商品推荐
export const getRecommend = (params: object) => {
  // return request({
  //   url: '/product/api/spu/hotSpuTopList',
  //   // url: '/product/api/recommend/recommend',
  //   method: 'get',
  //   data: params
  // })
}
// 商品点击量
export const putRecommendClick = (params: object) => {
  // return request({
  //   url: '/product/api/recommend/update',
  //   method: 'get',
  //   data: params
  // })
}

// 获取优惠卷
export const getcoupon = (params: object) => {
  // return request({
  //   url: '/coupon/center',
  //   method: 'get',
  //   data: params
  // })
}

// 领取优惠卷
export const userCoupon = (params: object) => {
  // return request({
  //   url: '/coupon/user/save',
  //   method: 'post',
  //   data: params
  // })
}


// 获取文章内容
export const contentIndex = () => {
  // return request({
  //   url: '/cms/api/content/index',
  //   method: 'get'
  // })
}

// 点击增加阅读量
export const readContent = (params: object) => {
  // return request({
  //   url: '/cms/api/content/update/read',
  //   method: 'get',
  //   data: params
  // })
}

export const getContentDetail = (params: object) => {
  // return request({
  //   url: '/cms/api/content/detail',
  //   method: 'get',
  //   data: params
  // })
}

export const getmessage = (params: object) => {
  // return request({
  //   url: '/system/notice/unread/total',
  //   method: 'get',
  //   data: params
  // })
}

// 创建智能客服
export const getDialogue = (params: object) => {
  // return request({
  //   url: '/im/conversation/robot/create',
  //   method: 'post',
  //   data: params
  // })
}


export const uploadFile = (params: object) => {
  // params.folderId = 2
  // return request({
  //   url: '/source/pic/upload',
  //   method: 'post',
  //   data: params
  // })
}


// 隐私类型查询
export const getPrivate = (id: number) => {
  const params = {
    id:id,
    isApi2:true
  }
  return request({
    url: '/oms/center/api/platformPolicy/detail',
    method: 'get',
    data: params
  })
}
// 隐私类型查询 1->用户协议；2->平台隐私；3->订货合同；
export const getbrandDetails = (id: string) => {
  // return request({
  //   url: '/product/api/brand/detail',
  //   method: 'get',
  //   data: {
  //     id
  //   }
  // })
}

// 客服防重登录
export const getCharToken = (userId) => {
  // return request({
  //   url: '/im/char/token?userId=' + userId,
  //   method: 'post',
  // })
}


// 获取IM列表
export const uploadIm = (params: object) => {
  // return request({
  //   url: '/system/sysFile/upload',
  //   method: 'post',
  //   data: params
  // })
}


// 方案列表获取
export const getSearchContent = (params: object) => {
  // return request({
  //   url: '/product/api/search/content',
  //   method: 'post',
  //   data: params
  // })
}


// 未读消息
export const getunReaderCount = (params: object) => {
  // return request({
  //   url: '/im/conversation/unReaderCount',
  //   method: 'get',
  //   data: params
  // })
}


// 关闭会话
export const endingConversation = (conversationId: object) => {
  // return request({
  //   url: '/im/conversation/endingConversation?conversationId='+conversationId,
  //   method: 'post'
  // })
}

// 获取已读或者未读的消息有多少条
export const getReadStatusCount = (params: object) => {
  params.isApi2 = true
  return request({
      url: '/user/center/message/info/client/count',
      method: 'get',
      data: params,
  });
}